import { render, staticRenderFns } from "./CustomerEmailForm.vue?vue&type=template&id=3a654ca6&"
import script from "./CustomerEmailForm.vue?vue&type=script&lang=js&"
export * from "./CustomerEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2983364112/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a654ca6')) {
      api.createRecord('3a654ca6', component.options)
    } else {
      api.reload('3a654ca6', component.options)
    }
    module.hot.accept("./CustomerEmailForm.vue?vue&type=template&id=3a654ca6&", function () {
      api.rerender('3a654ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Account/CustomerEmailForm.vue"
export default component.exports